import React, { useEffect, useRef } from 'react';
import styles from './QuestionTypeModal.module.css';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import AppsIcon from '@mui/icons-material/Apps';
import CollectionsIcon from '@mui/icons-material/Collections';
import { useTranslation } from 'react-i18next';

const QuestionTypeModal = ({ isOpen, onClose, onSelectQuestionType }) => {

    const { t } = useTranslation();
    const modalRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

    if (!isOpen) return null;

    const handleQuestionTypeSelect = (type) => {
        onSelectQuestionType(type);
        onClose();
    };

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent} ref={modalRef}>
                <h2 className={styles.modalTitle}>Choose the type of questions:</h2>

                <div className={styles.questionTypes}>
                    <div
                        className={styles.questionTypeItem}
                        onClick={() => handleQuestionTypeSelect('multipleChoice')}
                    >
                        <div className={styles.iconWrapper}>
                            <div className={styles.radioIcon}>
                                <div className={styles.radioInner}></div>
                            </div>
                        </div>
                        <span>{t("quiz.multipleTypeQuestion")}</span>
                    </div>

                    <div
                        className={styles.questionTypeItem}
                        onClick={() => handleQuestionTypeSelect('fillBlanks')}
                    >
                        <div className={styles.iconWrapper}>
                            <div className={styles.dashIcon}>—</div>
                        </div>
                        <span>{t("quiz.fillInTheBlanks")}</span>
                    </div>

                    <div
                        className={styles.questionTypeItem}
                        onClick={() => handleQuestionTypeSelect('checkboxes')}
                    >
                        <div className={styles.iconWrapper}>
                            <div className={styles.checkboxIcon}>
                                <CheckBoxIcon size={14} color="#000" />
                            </div>
                        </div>
                        <span>{t("quiz.checkboxes")}</span>
                    </div>

                    <div
                        className={styles.questionTypeItem}
                        onClick={() => handleQuestionTypeSelect('trueFalse')}
                    >
                        <div className={styles.iconWrapper}>
                            <div>
                                {/* <div className={styles.toggleCircle}></div> */}
                                <ToggleOffIcon />
                            </div>
                        </div>
                        <span>{t("quiz.trueFalse")}</span>
                    </div>

                    <div
                        className={styles.questionTypeItem}
                        onClick={() => handleQuestionTypeSelect('grid')}
                    >
                        <div className={styles.iconWrapper}>
                            <AppsIcon />
                        </div>
                        <span>{t("quiz.grid")}</span>
                    </div>

                    <div
                        className={styles.questionTypeItem}
                        onClick={() => handleQuestionTypeSelect('imageChoice')}
                    >
                        <div className={styles.iconWrapper}>
                            <CollectionsIcon size={20} />
                        </div>
                        <span>{t("quiz.imageChoice")}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QuestionTypeModal;